import { render } from "./GenerateAdditionalReport.vue?vue&type=template&id=b4fc993c&scoped=true"
import script from "./GenerateAdditionalReport.vue?vue&type=script&lang=js"
export * from "./GenerateAdditionalReport.vue?vue&type=script&lang=js"

import "./GenerateAdditionalReport.vue?vue&type=style&index=0&id=b4fc993c&scoped=true&lang=scss"

import exportComponent from "J:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b4fc993c"]])

export default __exports__